<template>
<div class="d-flex vh-100 login-page"> 
  <div
    class="d-flex align-items-center justify-content-center"
    style="width: 33.333%; background-color: #016690;"
  >
  <div style="width: 288px;"> 
    <div class="d-flex align-items-center mb-2">
      <img
        src="../assets/LogoComplementCubeBlue.png"
        alt="Logo"
        style="width: 32px; height: 32px; object-fit: contain;"
      />
      <span
        class="font-weight-bold ml-2 text-white"
        style="font-size: 18px;"
      >
        Cube <span style="color: #ffb171;">Lease</span>
      </span>
    </div>
    <p
      style="
        color: #f0eee9;
        font-size: 14px;
        line-height: 1.4;
        text-align: left;
      "
      >
        Automatiza tu gestión de NIIF 16 y pasa tus contratos al balance en minutos.
    </p> 
      <b-form @submit.prevent="handleLogin">
        <b-form-input
          id="email"
          v-model="email"
          placeholder="Correo electrónico"
          class="mb-3"
        />
        <b-form-input
          id="password"
          v-model="password"
          type="password"
          placeholder="Contraseña"
          class="mb-3"
        />
        <div class="d-flex justify-content-between align-items-center mb-3">
          <!-- <b-form-checkbox v-model="form.remember" class="text-white small">
            Recuérdame
          </b-form-checkbox> -->
          <button
            type="button"
            @click="openResetDialog"
            style="cursor: pointer; color: white; font-size: 12px; text-decoration: underline; background: transparent; border: 0; padding: 0;"
          >
            {{ labels.forgot }}
          </button>
        </div>
        <b-button
          type="submit"
          block
          pill
          :disabled="isLoading"
          class="login-submit-btn"
          style="
            background-color: #05344c;
            border-color: #05344c;
          "
        >
          <span class="login-submit-content">
            <b-spinner v-if="isLoading" small></b-spinner>
            {{ isLoading ? labels.loginLoading : labels.login }}
          </span>
        </b-button>
        <p v-if="error" class="invalid-login mt-2 mb-0" style="color: #ffd6d6; font-size: 12px;">
          {{ errorMessage }}
        </p>
      </b-form>
      <div
          class="text-center mt-3"
          style="font-size: 10px; color: #d1d5db;"
        >
          Powered by Complement IT SaaS
</div>
 
      </div>
</div>
 
    <div
      class="position-relative"
      style="width: 66.667%;"
    >
<img
        src="../assets/bg.png"
        alt="Background"
        class="w-100 h-100"
        style="object-fit: cover;"
      />
 
<div
        class="position-absolute"
        style="
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.1);
        "
      />
</div>
  <div v-if="mfaSuccessLoading" class="mfa-loading-overlay">
    <div class="mfa-loading-card">
      <b-spinner></b-spinner>
      <p>{{ labels.mfaLoading }}</p>
    </div>
  </div>

  <b-modal
    v-model="showDialog"
    centered
    hide-footer
    hide-header-close
    title="Restablecer contraseña"
    header-class="reset-modal-header"
    title-class="reset-modal-title"
    body-class="reset-modal-body"
    :no-close-on-backdrop="resetLoading"
    :no-close-on-esc="resetLoading"
    class="reset-password-dialog"
  >
    <div class="reset-dialog-content">
      <div class="reset-step-chip">{{ resetStepLabel }}</div>
      <p class="reset-dialog-subtitle">{{ resetSubtitle }}</p>
      <p v-if="resetError" class="invalid-login">{{ resetError }}</p>

      <b-form-input
        v-if="resetStep === 1"
        v-model="resetForm.email"
        type="email"
        class="reset-input"
        :placeholder="labels.resetEmailLabel"
        @keyup.enter="handleResetAction()"
      />

      <b-form-input
        v-if="resetStep === 2"
        v-model="resetForm.code"
        maxlength="6"
        class="reset-input"
        :placeholder="labels.resetCodeLabel"
        @keyup.enter="handleResetAction()"
      />
      <div v-if="resetStep === 2" class="reset-action-link" @click="resendResetCode()">{{ labels.resendCode }}</div>

      <b-form-input
        v-if="resetStep === 3"
        v-model="resetForm.password"
        type="password"
        class="reset-input"
        :placeholder="labels.newPassword"
        @keyup.enter="handleResetAction()"
      />
      <b-form-input
        v-if="resetStep === 3"
        v-model="resetForm.confirmPassword"
        type="password"
        class="reset-input"
        :placeholder="labels.confirmPassword"
        @keyup.enter="handleResetAction()"
      />
      <div v-if="resetStep === 3" class="password-policy-box">
        <div class="password-policy-title">{{ labels.passwordPolicyTitle }}</div>
        <div class="password-policy-item">{{ labels.policyLength }}: {{ passwordPolicy.minLength }} - {{ passwordPolicy.maxLength }}</div>
        <div v-if="passwordPolicy.requireUppercase" class="password-policy-item">{{ labels.policyUppercase }}</div>
        <div v-if="passwordPolicy.requireLowercase" class="password-policy-item">{{ labels.policyLowercase }}</div>
        <div v-if="passwordPolicy.requireNumber" class="password-policy-item">{{ labels.policyNumber }}</div>
        <div v-if="passwordPolicy.requireSpecial" class="password-policy-item">{{ labels.policySpecial }}</div>
      </div>
    </div>
    <div class="reset-dialog-actions d-flex justify-content-end mt-3">
      <b-button class="mr-2 reset-btn-secondary" @click="closeResetDialog()">{{ labels.close }}</b-button>
      <b-button class="reset-btn-primary" @click="handleResetAction()" :disabled="resetLoading">
        {{ resetPrimaryButtonLabel }}
      </b-button>
    </div>
  </b-modal>

  <b-modal
    v-model="mfaStep"
    centered
    hide-header-close
    hide-footer
    :title="labels.verify"
    header-class="reset-modal-header"
    title-class="reset-modal-title"
    body-class="reset-modal-body"
    class="mfa-dialog"
  >
    <b-form-input
      v-model="mfaCode"
      maxlength="6"
      class="reset-input"
      :placeholder="labels.code"
      @keyup.enter="verifyMfaCode"
      autofocus
    />
    <p v-if="error" class="invalid-login" style="color: red; font-size: 14px;">
      {{ errorMessage }}
    </p>
    <div style="display: flex; justify-content: space-between; margin-top: 14px;">
      <span
        @click="resendMfaCode"
        class="reset-action-link"
      >
        {{ labels.resendCode }}
      </span>
      <span
        @click="mfaStep = false"
        style="cursor: pointer; color: #666; font-size: 13px;"
      >
        {{ labels.changeUser }}
      </span>
    </div>
    <div class="reset-dialog-actions d-flex justify-content-end mt-3">
      <b-button class="mr-2 reset-btn-secondary" @click="mfaStep = false">{{ labels.close }}</b-button>
      <b-button
        class="reset-btn-primary"
        @click="verifyMfaCode"
        :disabled="mfaSuccessLoading"
      >
        <span v-if="mfaSuccessLoading">{{ labels.mfaLoading }}</span>
        <span v-else>{{ labels.verify }}</span>
      </b-button>
    </div>
  </b-modal>

  </div>
</template>
 
<script>
import Auth from "@/services/Authentication";

export default {
  data:() => ({
    form: {
      email: "",
      password: "",
      remember: false
    },
    email: "",
    password: "",
    showDialog: false,
    isLoading: false,
    error: false,
    errorMessage: "",
    isFetching: true,
    resetLoading: false,
    resetStep: 1,
    resetError: "",
    resetForm: {
      email: "",
      resetToken: "",
      code: "",
      password: "",
      confirmPassword: "",
    },
    passwordPolicy: {
      minLength: 8,
      maxLength: 20,
      requireUppercase: true,
      requireLowercase: true,
      requireNumber: true,
      requireSpecial: true,
    },
    mfaStep: false,
    mfaToken: "",
    mfaCode: "",
    mfaSuccessLoading: false
  }),

  computed:{
    labels(){
      if (this.$store.state._language == "es-ES") {
        return {
          greeting: "Iniciar Sesión",
          info: "Ingresa los datos que utilizaste para el registro",
          email: "Correo Electrónico",
          password: "Contraseña",
          code: "Codigo de verificacion",
          login: "Ingresar",
          loginLoading: "Validando...",
          verify: "Verificar codigo",
          mfaLoading: "Verificando acceso...",
          resendCode: "Reenviar código",
          changeUser: "Cambiar usuario",
          lang: "English Version",
          err: "Credenciales Incorrectas",
          errCode: "Codigo Incorrecto",
          forgot: "Olvidé mi contraseña",
          close: "Cerrar",
          genericError: "Algo pasó, intentalo de nuevo",
          resetTitle: "Restablecer contraseña",
          resetStep1: "Paso 1 de 3",
          resetStep2: "Paso 2 de 3",
          resetStep3: "Paso 3 de 3",
          resetSubtitle1: "Ingresa tu correo para recibir un codigo de seguridad.",
          resetSubtitle2: "Revisa tu correo e ingresa el codigo que te enviamos.",
          resetSubtitle3: "Define una nueva contraseña para tu cuenta.",
          resetEmailLabel: "Correo electrónico",
          resetCodeLabel: "Codigo de verificacion",
          sendCode: "Enviar codigo",
          resetCodeSent: "Codigo enviado al correo",
          resetCodeRequired: "Debes ingresar el codigo",
          resetCodeVerified: "Codigo verificado",
          resetEmailRequired: "Debes ingresar un correo",
          newPassword: "Nueva contraseña",
          confirmPassword: "Confirmar contraseña",
          updatePassword: "Actualizar contraseña",
          passwordPolicyTitle: "Requisitos de contraseña",
          policyLength: "Longitud",
          policyUppercase: "Debe incluir al menos una mayúscula",
          policyLowercase: "Debe incluir al menos una minúscula",
          policyNumber: "Debe incluir al menos un número",
          policySpecial: "Debe incluir al menos un caracter especial",
          resetPasswordRequired: "Debes completar ambos campos de contraseña",
          resetPasswordsNoMatch: "Las contraseñas no coinciden",
          resetSuccess: "Contraseña actualizada correctamente",
          sentence: "Control de Facturas de Proveedores",
          tittleImg: "Herramienta para la Consolidación de los Estados Financieros de los Grupos Económicos",
        };
      
      }else{

        return  {
          greeting: "Login",
          info: "Fill the fields with the registration information you provide",
          email: "E-mail Address",
          password: "Password",
          code: "Verification code",
          login: "Login",
          loginLoading: "Validating...",
          verify: "Verify code",
          mfaLoading: "Verifying access...",
          resendCode: "Resend code",
          changeUser: "Change user",
          lang: "Versión en Español",
          err: "Invalid Credentials",
          errCode: "Invalid Code",
          forgot: "Forgot my password",
          close: "Close",
          genericError: "Something went wrong, please try again",
          resetTitle: "Reset password",
          resetStep1: "Step 1 of 3",
          resetStep2: "Step 2 of 3",
          resetStep3: "Step 3 of 3",
          resetSubtitle1: "Enter your email to receive a security code.",
          resetSubtitle2: "Check your email and enter the code we sent.",
          resetSubtitle3: "Set a new password for your account.",
          resetEmailLabel: "Email",
          resetCodeLabel: "Verification code",
          sendCode: "Send code",
          resetCodeSent: "Code sent to email",
          resetCodeRequired: "You must enter the code",
          resetCodeVerified: "Code verified",
          resetEmailRequired: "You must enter an email",
          newPassword: "New password",
          confirmPassword: "Confirm password",
          updatePassword: "Update password",
          passwordPolicyTitle: "Password requirements",
          policyLength: "Length",
          policyUppercase: "Must include at least one uppercase letter",
          policyLowercase: "Must include at least one lowercase letter",
          policyNumber: "Must include at least one number",
          policySpecial: "Must include at least one special character",
          resetPasswordRequired: "You must complete both password fields",
          resetPasswordsNoMatch: "Passwords do not match",
          resetSuccess: "Password updated successfully",
          sentence: "Start to improve your business financial operations",
          tittleImg: "Tool for conciliation of states financiers of an economic group"
        };
      }
    },
    resetStepLabel() {
      if (this.resetStep === 1) return this.labels.resetStep1;
      if (this.resetStep === 2) return this.labels.resetStep2;
      return this.labels.resetStep3;
    },
    resetSubtitle() {
      if (this.resetStep === 1) return this.labels.resetSubtitle1;
      if (this.resetStep === 2) return this.labels.resetSubtitle2;
      return this.labels.resetSubtitle3;
    },
    resetPrimaryButtonLabel() {
      if (this.resetStep === 1) return this.labels.sendCode;
      if (this.resetStep === 2) return this.labels.verify;
      return this.labels.updatePassword;
    }
  },
  methods: {
    async handleLogin() {
      if (this.isLoading) return;
      const normalizedEmail = String(this.email || "").trim();
      const data = {
        'email': normalizedEmail,
        'password': this.password,
      }
      
      this.isLoading = true;
      this.error = false;
      this.errorMessage = "";
      
      Auth.login(data)
        .then((response) => {
          const userData = response.data;
          
          if (userData.requiresMfa || userData.mfaToken) {
            this.mfaToken = userData.mfaToken || userData.token;
            this.mfaStep = true;
            this.mfaCode = "";
            if (this.$toast) this.$toast.info(this.labels.resetCodeSent);
            this.isLoading = false;
            return;
          }
          
          userData.isAuthenticated = true;
          this.$store.commit("setData", userData);
          
          const route = this.getRouteByRole(userData.userRole);
          this.$router.push(route);
        })
        .catch((err) => {
          this.error = true;
          this.errorMessage = err.response?.data?.message || this.labels.err;
          if (this.$toast) this.$toast.error(this.errorMessage);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getRouteByRole(role) {
      const routes = {
        'ADM': {name: 'home'},
        'COM': {name: 'home'},
        'APP': {name: 'list'},
        'CHK': {name: 'list'},
        'AGN': {name: 'pending'}
      };
      return routes[role] || {name: 'home'};
    },

    async verifyMfaCode() {
      if (!this.mfaCode || this.mfaCode.length < 6) {
        this.error = true;
        this.errorMessage = this.labels.errCode;
        return;
      }
      
      this.mfaSuccessLoading = true;
      
      Auth.verifyMfa({
        mfaToken: this.mfaToken,
        code: this.mfaCode
      })
      .then((response) => {
        const userData = response.data;
        userData.isAuthenticated = true;
        this.$store.commit("setData", userData);
        this.mfaStep = false;
        this.$router.push({name: 'home'});
      })
      .catch((err) => {
        this.error = true;
        this.errorMessage = err.response?.data?.message || this.labels.errCode;
      })
      .finally(() => {
        this.mfaSuccessLoading = false;
      });
    },

    resendMfaCode() {
      Auth.resendMfaCode({ mfaToken: this.mfaToken })
        .then(() => {
          if (this.$toast) this.$toast.success(this.labels.resetCodeSent);
        })
        .catch(() => {
          if (this.$toast) this.$toast.error(this.labels.genericError);
        });
    },
 
    openResetDialog() {
      this.loadPasswordPolicy();
      this.showDialog = true;
      this.resetStep = 1;
      this.resetError = "";
      this.resetLoading = false;
      this.resetForm = {
        email: "",
        resetToken: "",
        code: "",
        password: "",
        confirmPassword: "",
      };
    },

    async forgotPassword() {
      this.openResetDialog();
    },

    closeResetDialog() {
      this.showDialog = false;
      this.resetLoading = false;
      this.resetError = "";
    },

    handleResetAction() {
      if (this.resetStep === 1) {
        this.requestResetCode();
        return;
      }
      if (this.resetStep === 2) {
        this.verifyResetCode();
        return;
      }
      this.confirmResetPassword();
    },

    requestResetCode() {
      this.resetError = "";
      if (!this.resetForm.email) {
        this.resetError = this.labels.resetEmailRequired;
        return;
      }

      this.resetLoading = true;
      Auth.requestPasswordResetCode({ email: this.resetForm.email })
        .then((response) => {
          this.resetForm.resetToken = response.data.resetToken;
          this.resetStep = 2;
          if (this.$toast) this.$toast.success(this.labels.resetCodeSent);
        })
        .catch((err) => {
          this.resetError = (err.response && err.response.data && err.response.data.message) || this.labels.genericError;
        })
        .finally(() => {
          this.resetLoading = false;
        });
    },

    resendResetCode() {
      if (!this.resetForm.email) {
        this.resetError = this.labels.resetEmailRequired;
        return;
      }
      this.requestResetCode();
    },

    verifyResetCode() {
      this.resetError = "";
      if (!this.resetForm.code) {
        this.resetError = this.labels.resetCodeRequired;
        return;
      }

      this.resetLoading = true;
      Auth.verifyPasswordResetCode({
        resetToken: this.resetForm.resetToken,
        code: this.resetForm.code,
      })
        .then(() => {
          this.resetStep = 3;
          if (this.$toast) this.$toast.success(this.labels.resetCodeVerified);
        })
        .catch((err) => {
          this.resetError = (err.response && err.response.data && err.response.data.message) || this.labels.genericError;
        })
        .finally(() => {
          this.resetLoading = false;
        });
    },

    confirmResetPassword() {
      this.resetError = "";
      if (!this.resetForm.password || !this.resetForm.confirmPassword) {
        this.resetError = this.labels.resetPasswordRequired;
        return;
      }
      if (this.resetForm.password !== this.resetForm.confirmPassword) {
        this.resetError = this.labels.resetPasswordsNoMatch;
        return;
      }
      const policyErrors = this.validatePasswordByPolicy(this.resetForm.password);
      if (policyErrors.length) {
        this.resetError = policyErrors[0];
        return;
      }

      this.resetLoading = true;
      Auth.confirmPasswordReset({
        resetToken: this.resetForm.resetToken,
        password: this.resetForm.password,
        confirmPassword: this.resetForm.confirmPassword,
      })
      .then(() => {
        if (this.$toast) this.$toast.success(this.labels.resetSuccess);
        this.closeResetDialog();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.details && err.response.data.details.length) {
          this.resetError = err.response.data.details[0];
          return;
        }
        this.resetError = (err.response && err.response.data && err.response.data.message) || this.labels.genericError;
      })
      .finally(() => {
        this.resetLoading = false;
      });
    },

    loadPasswordPolicy() {
      Auth.getPasswordPolicy()
      .then((response) => {
        if (response.data && response.data.policy) {
          this.passwordPolicy = response.data.policy;
        }
      })
      .catch(() => {});
    },

    validatePasswordByPolicy(password) {
      const errors = [];
      const p = this.passwordPolicy;

      if (password.length < p.minLength) {
        errors.push(`${this.labels.policyLength}: ${p.minLength} - ${p.maxLength}`);
      }
      if (password.length > p.maxLength) {
        errors.push(`${this.labels.policyLength}: ${p.minLength} - ${p.maxLength}`);
      }
      if (p.requireUppercase && !/[A-Z]/.test(password)) {
        errors.push(this.labels.policyUppercase);
      }
      if (p.requireLowercase && !/[a-z]/.test(password)) {
        errors.push(this.labels.policyLowercase);
      }
      if (p.requireNumber && !/[0-9]/.test(password)) {
        errors.push(this.labels.policyNumber);
      }
      if (p.requireSpecial && !/[^A-Za-z0-9]/.test(password)) {
        errors.push(this.labels.policySpecial);
      }

      return errors;
    }
  },
  beforeMount(){
    if(this.$store.state.isAuthenticated){
      let nextRoute = "";
    switch(this.$store.state.userRole){
          case 'ADM':
            nextRoute = {name: 'home'};
            break;
          case 'COM':
            nextRoute = {name: 'home'};
            break;
          case 'APP':
            nextRoute = {name: 'list'};
            break;
          case 'CHK':
            nextRoute = {name: 'list'};
            break;
          case 'AGN':
            nextRoute = {name: 'pending'};
            break;
        }
          this.$router.push(nextRoute);

    }
  }
};
</script>

<style src="./main.css"></style>
